import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsDataManagerDataSourceRoute: InvariantJiraRoute = {
	name: 'assets-data-manager-data-source',
	path: '/jira/assets/data-manager/object-classes/data-source/:dataSourceId/:tab(configuration|data|activity)?',
	exact: true,
};
